import React, { Component } from "react"
import Section from "components/layout/Section"
import NewEntry from "./New_Entry"

class NewEntryView extends Component {
  render() {
    return (
      <Section>
        <NewEntry {...this.props} />
      </Section>
    )
  }
}

export default NewEntryView
